/** Phone-only hardware niceties: vibration, screen wake lock and landscape lock. All best-effort. */

export function haptic(ms: number = 10): void {
  try {
    navigator.vibrate?.(ms); // not on iOS Safari; silently nothing there
  } catch {
    // vibrate can throw before the first user gesture
  }
}

let wakeLock: any = null;

async function acquireWakeLock() {
  try {
    if (document.visibilityState === 'visible') wakeLock = await (navigator as any).wakeLock?.request('screen');
  } catch {
    // denied (low battery, no gesture yet): the screen just dims as usual
  }
}

async function lockLandscape() {
  try {
    // orientation.lock() only works fullscreen (installed PWA; the manifest also asks for landscape).
    // Don't requestFullscreen() ourselves: a fullscreen element ignores the virtual viewport meta and
    // the whole UI re-lays out zoomed in. iOS supports neither (the rotate hint covers it).
    await (screen.orientation as any)?.lock?.('landscape');
  } catch {
    // unsupported or refused
  }
}

let armed = false;

/** Both APIs need a user gesture, so arm them on the first touch after entering the game. */
export function keepScreenReady(): void {
  if (armed) return;
  armed = true;
  const go = () => {
    window.removeEventListener('pointerdown', go, true);
    void acquireWakeLock();
    void lockLandscape();
  };
  window.addEventListener('pointerdown', go, true);
  // the browser drops the wake lock whenever the tab is hidden
  document.addEventListener('visibilitychange', () => {
    if (wakeLock?.released !== false) void acquireWakeLock();
  });
}

/** Tap feedback on every UI button / icon slot. */
export function hapticOnUiTaps(root: HTMLElement): void {
  root.addEventListener('pointerdown', (e) => {
    if ((e.target as HTMLElement).closest('.button, .iconslot, .collapse-arrow')) haptic(8);
  });
}
